module.exports = __webpack_public_path__ + "img/SB.e5d74b24.jpg";